import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.587 0L.01 18.132l1.413 1.38L20 1.38 18.587 0zm-8.323 13.642l-1.74 1.698c3.25 1.257 6.473-1.879 5.181-5.057l-1.739 1.697a1.966 1.966 0 01-1.702 1.662zm7.727 2.954c0 .539-.448 1.453-1 1.453H6.24L4.24 20h13.752c1.103 0 1.999-1.351 1.999-2.428V4.149l-2 1.951v10.496zM1.999 13.432L0 15.383V6.2c0-1.078.895-1.81 1.999-1.81h2.999V2.54c0-1.168.97-2.052 2.167-2.052h7.828l-2 1.951H7.997c-.553 0-1-.041-1 .499V4.39h4.755l-2 1.951H3c-.553 0-1-.04-1 .499v6.592z",
  fillRule: "evenodd"
});

var Camera3Icon = function Camera3Icon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
Camera3Icon.defaultProps = {
  size: 1.5
};
export default Camera3Icon;